import script from "./CategoryItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryItem.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryItem.vue?vue&type=style&index=0&id=244dd9d3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-244dd9d3"]])

export default __exports__